const SectionCorporate = Class(
	/**
	 * @lends {SectionCorporate#}
	 */
	{
		__NAME: 'SectionCorporate',

		background: null,
		bodyClass: 'small-nav',
		menuItem: 'corporate',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionCorporate'
			});
		},

		draw() {
			this.node.append(this.layout.ct());
			new T.Hero({
				className: 'hero-simple',
				backgroundClass: `background-picture-corporate`,
				title: mkE({
					tag: 'span',
					innerHTML: D.Lang.get('corporate.welcome.title.new')
				}),
				text: D.Lang.get('corporate.welcome.text.new'),
				button: this._buyBtn = mkE({
					tag: 'a',
					onclick: function () {
						D.scrollIntoView(document.querySelector('#corporate-packages'), null, 100)
					},
					className: 'button button-large button-pink',
					text: D.Lang.get('corporate.welcome.button')
				})
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'case-studies-wrapper',
				els: [
					this._caseStudies = new T.CaseStudies('corporate', this.apiCall)
				]
			}).append(this.node);

			this._testimonials = T.Quotes.get('corporate', {
				youtubeVideoId: '2bfRVSKZjlM',
				videoSchemaMarkup: {
					"@context": "https://schema.org",
					"@type": "VideoObject",
					"name": "Korporatīvie un komandu saliedēšanas pasākumi",
					"description": "Roadgames korporatīvie pasākumi uzņēmumiem - komandas saliedēšana un team building orientēšanās spēles Latvijā un ārvalstīs. Izvēlieties kādu no Roadgames spēlēm vai izveidojiet unikālu sava uzņēmuma spēli.",
					"thumbnailUrl": [
						"https://i3.ytimg.com/vi/xljiF4WLu1Q/maxresdefault.jpg"
					],
					"uploadDate": "2023-01-11",
					"contentUrl": "https://www.youtube.com/watch?v=xljiF4WLu1Q&ab_channel=Roadgames",
					"duration": "PT3M56S"
				}
			});
			if( this._testimonials ) {
				mkE({
					tag: 'div',
					className: 'testimonials-wrapper',
					els: [
						this._testimonials
					]
				}).append(this.node);
			}

			mkE({
				tag: 'div',
				className: 'container corporate-steps',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('corporate.steps.title')
					},
					{
						tag: 'div',
						className: 'corporate-steps-columns',
						els: [
							{
								tag: 'div',
								className: 'steps column',
								els: [
									{
										tag: 'h3',
										text: D.Lang.get('corporate.steps.game.title')
									},
									{
										tag: 'div',
										els: [
											this._drawStepInfo('game', 0),
											this._drawStepInfo('game', 1),
											this._drawStepInfo('game', 2),
											this._drawStepInfo('game', 3)
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'steps column',
								els: [
									{
										tag: 'h3',
										text: D.Lang.get('corporate.steps.make.title')
									},
									{
										tag: 'div',
										els: [
											this._drawStepInfo('make', 0),
											this._drawStepInfo('make', 1),
											this._drawStepInfo('make', 2),
											this._drawStepInfo('make', 3)
										]
									}
								]
							}
						]
					}
				]
			}).append(this.node);

			let tasks = [
				'matchmaker',
				'g-spot',
				'explorer',
				'sprinter',
				'hunter',
				'groupie',
				'expert',
				'detective',
				'coder',
				'golddigger'
			];

			mkE({
				tag: 'div',
				className: 'how-to-wrapper',
				els: [
					this._howTo = new T.HowTo(
						tasks,
						tasks[0],
						null,
						D.Lang.get('how-to.corporate.h2').replace('%COUNT%', tasks.length),
						null,
						null,
						'corporate'
					)
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				id: 'corporate-packages',
				className: 'container',
				els: [
					this._packages = new T.CorporatePackages('corporate')
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'easy-access-wrapper',
				els: [
					new T.EasyAccess()
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				id: 'corp-contact-form',
				className: 'corporate-form-wrapper',
				els: [
					new T.CorporateContactUs({
						howRequired: true
					})
				]
			}).append(this.node);

			this._drawFaq();

			this._drawCta();

			this.apiCall.call();
		},

		_drawStepInfo( type, index ) {
			let key = 'corporate.steps.info.' + type + '.' + index;
			let list = [];
			for( let i = 0; i < 3; i++ ) {
				list.push({
					tag: 'li',
					text: D.Lang.get(key + '.' + 'list' + i)
				});
			}

			return mkE({
				tag: 'div',
				className: 'step step-' + type + '-' + index,
				els: [
					{
						tag: 'div',
						className: 'image'
					},
					{
						tag: 'div',
						className: 'list data',
						els: [
							{
								tag: 'h4',
								className: 'caption',
								text: D.Lang.get(key + '.' + 'title')
							},
							{
								tag: 'ul',
								className: 'text',
								els: list
							}
						]
					}
				]
			})
		},

		_drawFaq() {
			mkE({
				tag: 'div',
				className: 'container',
				els: [
					new T.FAQ({
						title: D.Lang.get('corporate.faq.title'),
						prefix: 'corporate.faq'
					})
				]
			}).append(this.node)
		},

		_drawCta: function () {
			this._cta = new T.CallToAction({
				id: 'CorporateCTA',
				style: {
					height: '80px'
				},
				els: [
					{
						tag: 'div',
						els: [
							{
								tag: 'a',
								onclick: function () {
									D.scrollIntoView(document.getElementById('corp-contact-form'));
								},
								className: 'button button-pink',
								text: D.Lang.get('corporate.cta.btn.contact')
							},
							{
								tag: 'span',
								text: D.Lang.get('corporate.cta.text.contact')
							}
						]
					},
					{
						tag: 'div',
						els: [
							{
								tag: 'a',
								onclick: function () {
									D.scrollIntoView(document.querySelector('#corporate-packages'), null, 100);
								},
								className: 'button button-turquoise',
								text: D.Lang.get('corporate.cta.btn.offer')
							}
						]
					}
				]
			}).append(document.body);
		},

		onShow() {
			this._isMobile = screen.width <= 768;
			if( this._caseStudies ) {
				this._caseStudies.onShow();
			}
			if( this._testimonials ) {
				this._testimonials.onShow();
			}
			if( this._gameSetup ) {
				this._gameSetup.onShow();
			}
			if( this._howTo ) {
				this._howTo.onShow();
			}
			if( this._packages ) {
				this._packages.onShow();
			}
			if( window.location.hash === '#corp-contact-form' ) {
				setTimeout(function () {
					D.scrollIntoView(document.getElementById('corp-contact-form'));
				}, 666);
			}
			this.onScroll();
		},

		onLeave() {
			if( this._caseStudies ) {
				this._caseStudies.onLeave();
			}
			if( this._testimonials ) {
				this._testimonials.onLeave();
			}
			if( this._gameSetup ) {
				this._gameSetup.onLeave();
			}
			if( this._howTo ) {
				this._howTo.onLeave();
			}
			if( this._cta ) {
				this._cta.remove();
				this._cta = null;
			}
		},

		onBack() {
			this._packages.onBack();
		},

		onScroll() {
			if( this._cta && this._buyBtn ) {
				if( screen.width < 720 || this._buyBtn.offsetTop + 200 < window.scrollY ) {
					if( !this._cta.active ) {
						this._cta.show();
					}
				} else if( this._cta.active ) {
					this._cta.hide();
				}
			}
		}
	},
	Section
);